import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useTIN } from '@src/state/taxInformation/hooks';
import { usePAARegistration } from '@src/state/PAARegistration/hooks';
import { UserRegistrationShell } from '@src/common/UserRegistrationShell';
import { UHCProviderLink } from '@src/common/UHCProviderLink';
import { UHCLink } from '@src/common/UHCLink';
import { useUser } from '@src/state/user/index';
import { config } from '@uhg-abyss/web/tools/config';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { LagoonContext } from '@src/AppContext/LagoonContext';

const MainContainer = styled('div', {
  border: '1px solid rgb(219, 219, 219)',
  background: '$white',
  padding: '25px',
  marginBottom: '20px',
});

const BoxHeader = styled('div', {
  position: 'relative',
  marginTop: '40px',
  marginBottom: '10px',
});

const BoxHeaderText = styled('h3', {
  fontWeight: 600,
  fontSize: '24px',
  width: '100%',
  color: '$primary1',
  fontFamily: '$heading',
});

const SaveDescription = styled('p', {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: '$primary',
});

const EmailDescription = styled('p', {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: '$primary',
  marginBottom: '0px',
});

export const EmailConfirmation = () => {
  const { firstName, lastName, email } = usePAARegistration.state();
  const { TINInfo } = useTIN.state();
  const { isAPIMarketPlaceUser } = useUser.state();
  const tinInfo = TINInfo == null ? { corpName: 'ABC Hopsital' } : TINInfo;

  const lagoonContext = React.useContext(LagoonContext);
  const uiMessages = lagoonContext.getTable('ui-messaging');

  return (
    <UserRegistrationShell
      showCancelLink={false}
      showOnlyOrgAndTin={isAPIMarketPlaceUser}
    >
      <MainContainer>
        <IconBrand
          icon="email"
          style={{ marginTop: 25 }}
          size={48}
          variant="twotone"
        />
        <BoxHeader>
          <BoxHeaderText>Message Sent</BoxHeaderText>
        </BoxHeader>
        <SaveDescription>
          An email has been sent to {firstName} {lastName} at {email} to invite
          them to enroll as the{' '}
          {isAPIMarketPlaceUser
            ? 'Secret Keeper'
            : 'Primary Access Administrator'}{' '}
          for the {tinInfo.corpName}
          {tinInfo.corpName && `'s`} UnitedHealthcare{' '}
          {isAPIMarketPlaceUser ? 'API Marketplace' : 'Provider Portal'}.
        </SaveDescription>
        {isAPIMarketPlaceUser && (
          <EmailDescription>
            An email will be sent to you when you can proceed with your
            registration.
          </EmailDescription>
        )}
      </MainContainer>
      {isAPIMarketPlaceUser ? (
        <UHCLink
          label="Return to API Marketplace"
          url={
            uiMessages.getRow('API_MARKETPLACE_WELCOME_URL')?.message ||
            config('API_MARKETPLACE_WELCOME_URL')
          }
          sameTab
        />
      ) : (
        <React.Fragment>
          <UHCProviderLink
            style={{
              margin: 'auto',

              display: 'inline-flex',
              marginTop: '20px',
              flexDirection: 'row',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          />
          <br />
          <UHCLink
            label="Return to Provider Portal"
            url={uiMessages.getRow('SDE_URL')?.message || config('SDE_URL')}
          />
        </React.Fragment>
      )}
    </UserRegistrationShell>
  );
};
